<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"
        ><i class="el-icon-s-home"></i
      ></el-breadcrumb-item>
      <el-breadcrumb-item
        v-if="currentCategory().parent_id !== undefined"
        :to="{ path: '/categories/' + currentCategory().parent_id }"
        :style="'color:' + getCategoryColorById(currentCategory().parent_id)"
      >
        {{ getCategoryNameById(currentCategory().parent_id) }}
      </el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{ path: '/categories/' + currentCategory().id }"
        :style="'color:' + currentCategory().color"
      >
        {{ currentCategory().name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
export default {
  props: ["id"],
  computed: {
    ...mapGetters([
      "getCategoryColorById",
      "getCategoryNameById",
      "currentCategory"
    ])
  },
  methods: {
    ...mapMutations(["setUrls", "changeCurrentCategory"])
  }
};
</script>
